import React from 'react';
import { Upload, DatePicker, Space } from 'antd';
import moment from 'moment';
import { MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBBtn, MDBCard, MDBCardBody, MDBCardTitle, MDBCol, MDBContainer, MDBFooter, MDBIcon, MDBNav, MDBNavItem, MDBNavLink, MDBRow, MDBTabContent, MDBTable, MDBTableBody, MDBTableHead, MDBTabPane } from 'mdbreact';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
// import TextField from '@material-ui/core/TextField';
// import Stepper from '@material-ui/core/Stepper';
// import Step from '@material-ui/core/Step';
// import StepLabel from '@material-ui/core/StepLabel';
// import StepContent from '@material-ui/core/StepContent';
import './NewVisa.css';
// import profile_pic from '../../Assets/blank-profile-picture.png';
import visa_img from '../../Assets/visa.svg'
import visaero_visa_img from "../../Assets/visaero-visa-ribbon.svg"
import visaero_evisa_img from "../../Assets/visaero-e-visa-ribbon.svg"
import disable_visa from "../../Assets/disabled_visa_ribon.svg"
import disable_evisa from "../../Assets/disabled_e-visa_ribon.svg"
import evisa_img from '../../Assets/e-visa.svg'
import info from '../../Assets/info_icon.svg'
import document_icon from '../../Assets/document_icon.svg'
import upload_icon from '../../Assets/upload_document.svg'
import delete_icon from '../../Assets/delete_icon.svg';
// import edit_icon from '../../Assets/edit_icon.svg';
// import move_icon from '../../Assets/move-icon.svg';
// import zoom_icon from '../../Assets/zoom-in_icon.svg';
import 'date-fns';
// import {
//     KeyboardDatePicker, MuiPickersUtilsProvider
// } from '@material-ui/pickers';
// import DateFnsUtils from '@date-io/date-fns';
import axios from '../../authAxios'
import { Redirect } from 'react-router-dom';
import './NewVisa.css';
import loader from '../../Assets/loader1.gif';

const { RangePicker } = DatePicker;
const { Dragger } = Upload;
// const brand_color = localStorage.getItem('brand_color')

var corflag = true
var visaflag = false
export class NewVisa extends React.Component {

    constructor(props) {
        super(props)
        var arrival_dt = new Date()
        arrival_dt.setDate(new Date().getDate() + 2)

        var departure_dt = new Date()
        departure_dt.setDate(new Date().getDate() + 7)

        this.state = {
            // visaValue: 1,
            // entryValue: 1,
            brand_color: "",
            dataObj: [],
            activeItem: "1",
            cor_checked: true,
            journey_start_date: arrival_dt,
            journey_end_date: departure_dt,
            origin_cioc: '',
            origin_country: [],
            nationality: '',
            nationality_cioc:'',
            nationalityArr: [],
            traveling_to: '',
            travelling_to_identity: '',
            travelling_to_country: '',
            travellingTo: [],
            applicants: 1,
            isOrigin: false,
            isNationality: false,
            isTravellingTo: false,
            visa_type: 'Standard',
            entry_type: 'Single',
            visa_id: '',
            visa_code: '',
            visa_fees: '',
            visa_category: '',
            total_days: '',
            isVisaType: false,
            isEntryType: false,
            isRequiredDoc: false,
            isUploadDoc: false,
            isOrganiseApplication: false,
            visaOffer: [],
            supported_currencies: [],
            touristVisa: [],
            businessVisa: [],
            studentVisa: [],
            transitVisa: [],
            tourist_Visa: [],
            requiredDocuments: [],
            uploadedDoc: [],
            docfile: '',
            loading: false,
            no_tourist: "",
            no_business: "",
            showVisaofferError: false,
            showDocumentError: false,
            supported_currency: [],
            selected_currency: '',
            detailMessage: "",
            adultFee: "",
            visaeroFee: "",
            currencyType: "",
            someMessage: "",
            additionalTaxes: [],
            totalAmount: "",
            card_style: 'card-input-element',
            showDeleteModall: false,
            cardToDelete: '',
            documentError: false,
            dimensions: {
                "width": "90%",
                "height": "50%"
            },
            defaultChecked: true,
            isError: false,
            ErrorMsg: '',
            card_input: 'card-input',
            modalText: "",
            difference: "",
            showSupportedCur: true,
            selected_visa_type: '',
            visa_duration_type: "",
            isCORRequired:false,
        }
        this.handleCORChange = this.handleCORChange.bind(this);
        this.handleNationalityChange = this.handleNationalityChange.bind(this);
        this.handleTravellingToChange = this.handleTravellingToChange.bind(this);
        this.handleVisaTypeChange = this.handleVisaTypeChange.bind(this);
        this.handleEntryTypeChange = this.handleEntryTypeChange.bind(this);
        this.handleApplicantsChange = this.handleApplicantsChange.bind(this);
        this.handleVisaOfferChange = this.handleVisaOfferChange.bind(this);
        this.handleOrganizeApplication = this.handleOrganizeApplication.bind(this);
        this.handleOptionChange = this.handleOptionChange.bind(this);
        this.deleteToggle = this.deleteToggle.bind(this);
    }

    toggle = tab => e => {

        if (this.state.activeItem !== tab) {
            // console.log("toggle")
            visaflag = true
            this.api_visaDocuments("")
            this.setState({
                activeItem: tab,
                visa_id: '',
                isError: false, showVisaofferError: false, showDocumentError: false,
                defaultChecked: false,
                card_input: ''
            });

        }
    };

    hideLoader = () => {
        this.setState({ loading: false });
        // console.log("hiding loader...")
    }

    showLoader = () => {
        this.setState({ loading: true });
        // console.log("showing loader...")
    }

    // onChangeVisaRadio = e => {
    //     console.log('radio checked', e.target.value);
    //     this.setState({
    //         visaValue: e.target.value,
    //     });
    //   };

    onChangeCheckBox(e) {
        // console.log(`checked = ${e.target.checked}`);
    }

    // onChangeEntryRadio = e => {
    // console.log('radio checked', e.target.value);
    // this.setState({
    //     entryValue: e.target.value,
    // });
    // };

    onChangeDate(dates, dateStrings) {
        // console.log('From: ', dates[0], ', to: ', dates[1]);
        // console.log('From: ', dateStrings[0], ', to: ', dateStrings[1]);
    }


    componentDidMount() {
        localStorage.setItem('process_flow', 'standard')
        localStorage.setItem('selected_visa_offer', '')
        this.setState({ brand_color: localStorage.getItem('brand_color') })
        this.setState({
            dimensions: {
                width: document.getElementById('footerRow').offsetWidth,
                height: 0,
            },
        });
        //getOriginCountries
        if (localStorage.getItem('host') == "visaero") {
            this.setState({ card_style: 'card-input-element' })
        } else if (localStorage.getItem('host') == "visadone") {
            this.setState({ card_style: 'vdcard-input-element' })
        }

        //this.setState({activeItem:"3"})

        this.setState({ selected_currency: localStorage.getItem('base_currency_symbol') })
        axios.get('https://ipapi.co/json/').then((response) => {
            let data = response.data;
            // console.log(data.country_name)
            // console.log(data.country_calling_code)
            localStorage.setItem("origin", data.country_name)
            this.setState({ origin_cioc: data.country_name })
            this.setState({ isOrigin: true })
            localStorage.setItem("nationality", data.country_name)
            this.setState({ nationality: data.country_name , nationality_cioc:data.country_code_iso3
            })
            this.setState({ isNationality: true })

            // console.log(localStorage.getItem('origin'))
            // console.log(localStorage.getItem('nationality'))

            this.setState({ visa_type: "Standard" })
            this.setState({ isVisaType: true })
            localStorage.setItem("visa_type", "Standard")

            this.setState({ entry_type: "Single" })
            this.setState({ isEntryType: true })
            localStorage.setItem("entry_type", "Single")

            if (localStorage.getItem('site_origin') != null && localStorage.getItem('site_origin') != "") {
                localStorage.setItem("origin", localStorage.getItem('site_origin'))
                this.setState({ origin_cioc: localStorage.getItem('site_origin') })
                localStorage.setItem("site_origin", "")
            }
            if (localStorage.getItem('site_nationality') != null && localStorage.getItem('site_nationality') != "") {
                localStorage.setItem("nationality", localStorage.getItem('site_nationality'))
                this.setState({ nationality: localStorage.getItem('site_nationality') })
                localStorage.setItem("site_nationality", "")
            }

            if (localStorage.getItem('site_start_date') != null && localStorage.getItem('site_start_date') != "") {
                console.log(">>>> " + localStorage.getItem('site_start_date'))
                var date = new Date(localStorage.getItem('site_start_date').replaceAll(" ", "/"))
                this.setState({ journey_start_date: date })
                localStorage.setItem("site_start_date", "")
            }

            if (localStorage.getItem('site_end_date') != null && localStorage.getItem('site_end_date') != "") {
                console.log(">>>> " + localStorage.getItem('site_end_date'))
                var date = new Date(localStorage.getItem('site_end_date').replaceAll(" ", "/"))
                this.setState({ journey_end_date: date })
                localStorage.setItem("site_end_date", "")
            }

            if (localStorage.getItem('site_entry_type') != null && localStorage.getItem('site_entry_type') != "") {

                this.setState({ entry_type: localStorage.getItem('site_entry_type') })
                localStorage.setItem("entry_type", localStorage.getItem('site_entry_type'))
                localStorage.setItem("site_entry_type", "")
            }

            if (localStorage.getItem('site_visa_type') != null && localStorage.getItem('site_visa_type') != "") {

                this.setState({ visa_type: localStorage.getItem('site_visa_type') })
                localStorage.setItem("visa_type", localStorage.getItem('site_visa_type'))
                localStorage.setItem("site_visa_type", "")
            }

            axios
                .post('/brule-engine/getTravellingTo', {
                    "origin": localStorage.getItem('origin'),//india
                    "nationality": localStorage.getItem('nationality'),//india
                    "host": localStorage.getItem('host')
                },
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                .then((res) => {
                    // console.log(res)
                    if (res.data.data === "success") {
                        this.setState({ travellingTo: res.data.dataobj.data })
                        this.setState({ travelling_to_identity: res.data.dataobj.data[0].identity })
                        localStorage.setItem("travelling_to_country", res.data.dataobj.data[0].name)
                        let travelling_To = res.data.dataobj.data[0].identity //ind_ind_uae
                        let destination = this.state.travellingTo.filter(destination => destination.identity == travelling_To)


                        //Conflicted code on 15-Mar
                        //this.setState({isTravellingTo: true})
                        // if(localStorage.getItem("travelling_to_identity") == "" || localStorage.getItem("travelling_to_identity") == null){
                        //     localStorage.setItem("travelling_to_identity", res.data.dataobj.data[0].identity)
                        //     this.setState({travelling_to_country: res.data.dataobj.data[0].name,
                        //         travelling_to: res.data.dataobj.data[0].cioc,
                        //         travelling_to_identity:res.data.dataobj.data[0].identity})
                        // }else{
                        //     for(var tt in res.data.dataobj.data){
                        //         if(tt.identity == localStorage.getItem("travelling_to_identity")){
                        //             this.setState({travelling_to_country: tt.name,
                        //                 travelling_to: tt.cioc,
                        //                 travelling_to_identity:tt.identity})
                        //         }
                        //     }

                        // }    

                        // this.setState({
                        //     travelling_to_country: res.data.dataobj.data[0].name,
                        //     travelling_to: res.data.dataobj.data[0].cioc,
                        //     travelling_to_identity: res.data.dataobj.data[0].identity
                        // })

                        this.setState({ isTravellingTo: true })


                        localStorage.setItem("travelling_to_identity", res.data.dataobj.data[0].identity)
                        this.setState({
                            travelling_to_country: res.data.dataobj.data[0].name,
                            travelling_to: res.data.dataobj.data[0].cioc,
                            travelling_to_identity: res.data.dataobj.data[0].identity
                        })

                        if (localStorage.getItem("site_travelling_to_identity") != "" && localStorage.getItem("site_travelling_to_identity") != null) {
                            localStorage.setItem("travelling_to_identity", localStorage.getItem("site_travelling_to_identity"))
                            localStorage.setItem("site_travelling_to_identity", "")
                            for (var tt in res.data.dataobj.data) {
                                if (res.data.dataobj.data[tt].identity == localStorage.getItem("travelling_to_identity")) {
                                    this.setState({
                                        travelling_to_country: res.data.dataobj.data[tt].name,
                                        travelling_to: res.data.dataobj.data[tt].cioc,
                                        travelling_to_identity: res.data.dataobj.data[tt].identity
                                    })
                                }
                            }
                        }


                        axios
                            .post('/visa/getVisaOffers', {
                                "travelling_to_identity": this.state.travelling_to_identity,
                                "host": localStorage.getItem('host')
                            },
                                {
                                    headers: {
                                        'Content-Type': 'application/json'
                                    }
                                })
                            .then((res) => {
                                // console.log("VISAAAOFFERSSSS ==> " , res);
                                // console.log(res.data.dataobj.visa[0].tourist)  
                                //this.setState({visaOffer: res.data.dataobj.visa})
                                if (res.data.dataobj === undefined) {
                                    //console.log("undefined resp");
                                    this.setState({ showSupportedCur: false })
                                } else {
                                    this.setState({ showSupportedCur: true })
                                }
                                var activeTouristObj = this.getActiveVisa(res.data.dataobj.visa[0].tourist)
                                var activeBusinessObj = this.getActiveVisa(res.data.dataobj.visa[1].business)
                                var activeStudentObj = this.getActiveVisa(res.data.dataobj.visa[2].student)
                                var activeTransitObj = this.getActiveVisa(res.data.dataobj.visa[3].transit)

                                var current_currency = localStorage.getItem("base_currency_symbol")

                                var supp_cur_arr = res.data.dataobj.supported_currencies
                                if (supp_cur_arr.indexOf(localStorage.getItem('base_currency_symbol')) >= 0) {
                                    console.log("current currency valid")
                                    this.setState({ selected_currency: localStorage.getItem('base_currency_symbol') })
                                } else {
                                    localStorage.setItem("base_currency_symbol", supp_cur_arr[0])
                                    this.setState({ selected_currency: supp_cur_arr[0] })
                                }

                                // if (activeTouristObj[0].visa.length > 0) {
                                //     var found = false
                                //     for (var key in activeTouristObj[0].visa[0].fees) {
                                //         if (key == current_currency) {
                                //             found = true
                                //             localStorage.setItem("base_currency_symbol", current_currency)
                                //             this.setState({ selected_currency: current_currency })
                                //             break;
                                //         }
                                //     }
                                //     if (!found) {
                                //         for (var key in activeTouristObj[0].visa[0].fees) {
                                //             console.log(">>> " + key)
                                //             localStorage.setItem("base_currency_symbol", key)
                                //             this.setState({ selected_currency: key })
                                //             break;
                                //         }
                                //     }

                                // } else if (activeBusinessObj[0].visa.length > 0) {
                                //     var found = false
                                //     for (var key in activeBusinessObj[0].visa[0].fees) {
                                //         if (key == current_currency) {
                                //             found = true
                                //             localStorage.setItem("base_currency_symbol", current_currency)
                                //             this.setState({ selected_currency: current_currency })
                                //             break;
                                //         }
                                //     }
                                //     if (!found) {
                                //         for (var key in activeBusinessObj[0].visa[0].fees) {
                                //             console.log(">>> " + key)
                                //             localStorage.setItem("base_currency_symbol", key)
                                //             this.setState({ selected_currency: key })
                                //             break;
                                //         }
                                //     }
                                // } else if (activeStudentObj[0].visa.length > 0) {
                                //     var found = false
                                //     for (var key in activeStudentObj[0].visa[0].fees) {
                                //         if (key == current_currency) {
                                //             found = true
                                //             localStorage.setItem("base_currency_symbol", current_currency)
                                //             this.setState({ selected_currency: current_currency })
                                //             break;
                                //         }
                                //     }
                                //     if (!found) {
                                //         for (var key in activeStudentObj[0].visa[0].fees) {
                                //             console.log(">>> " + key)
                                //             localStorage.setItem("base_currency_symbol", key)
                                //             this.setState({ selected_currency: key })
                                //             break;
                                //         }
                                //     }
                                // } else if (activeTransitObj[0].visa.length > 0) {
                                //     var found = false
                                //     for (var key in activeTransitObj[0].visa[0].fees) {
                                //         if (key == current_currency) {
                                //             found = true
                                //             localStorage.setItem("base_currency_symbol", current_currency)
                                //             this.setState({ selected_currency: current_currency })
                                //             break;
                                //         }
                                //     }
                                //     if (!found) {
                                //         for (var key in activeTransitObj[0].visa[0].fees) {
                                //             // console.log(">>> "+key)
                                //             localStorage.setItem("base_currency_symbol", key)
                                //             this.setState({ selected_currency: key })
                                //             break;
                                //         }
                                //     }
                                // }


                                this.setState({ supported_currencies: res.data.dataobj.supported_currencies })
                                this.setState({ touristVisa: activeTouristObj })
                                this.setState({ businessVisa: activeBusinessObj })
                                this.setState({ studentVisa: activeStudentObj })
                                this.setState({ transitVisa: activeTransitObj })
                                this.setState({ supported_currency: res.data.dataobj.supported_currencies })

                                if (this.state.touristVisa.length > 0) {
                                    // console.log(">>>> "+this.state.touristVisa[0].visa[0].visa_id)
                                    this.setState({ "visa_id": this.state.touristVisa[0].visa[0].visa_id })
                                    this.setState({ visa_duration_type: this.state.touristVisa[0].visa[0].duration_type })
                                    localStorage.setItem("visa_id", this.state.touristVisa[0].visa[0].visa_id)
                                    // console.log(">>> "+JSON.stringify(activeTouristObj))
                                    activeTouristObj[0].visa.map((t_visa) => {
                                        if (t_visa.visa_id === this.state.touristVisa[0].visa[0].visa_id) {
                                            // console.log(t_visa.visa_id)
                                            var visa_fees_struct = ""
                                            // if(localStorage.getItem('base_currency_symbol') == "INR"){
                                            //     visa_fees_struct = t_visa.fees.INR
                                            // } else if(localStorage.getItem('base_currency_symbol') == "AED"){
                                            //     visa_fees_struct = t_visa.fees.AED
                                            // } else if(localStorage.getItem('base_currency_symbol') == "USD"){
                                            //     visa_fees_struct = t_visa.fees.USD
                                            // } else if(localStorage.getItem('base_currency_symbol') == "NGN"){
                                            //     visa_fees_struct = t_visa.fees.NGN
                                            // } 
                                            visa_fees_struct = t_visa.fees[localStorage.getItem('base_currency_symbol')]
                                            this.setState({ showVisaofferError: false, selected_visa_type: t_visa.visa_type, visa_id: t_visa.visa_id, visa_code: t_visa.visa_code, total_days: t_visa.duration_days, visa_fees: visa_fees_struct, visa_category: "tourist" })
                                            // localStorage.setItem('visa_id',t_visa.visa_id)
                                            // localStorage.setItem('visa_code',t_visa.visa_code)
                                            // localStorage.setItem('total_days',t_visa.duration_days)
                                        }
                                    })

                                    axios
                                        .post('/visa/getVisaDocuments', {
                                            "travelling_to_identity": this.state.travelling_to_identity,
                                            "visa_id": this.state.touristVisa[0].visa[0].visa_id,
                                            "host": localStorage.getItem('host')
                                        },
                                            {
                                                headers: {
                                                    'Content-Type': 'application/json'
                                                }
                                            })
                                        .then((resp) => {
                                            // console.log(resp.data.dataobj.required_documents)
                                            this.setState({ requiredDocuments: resp.data.dataobj.required_documents })
                                            this.setState({ isRequiredDoc: true })
                                            this.setState({ isUploadDoc: true })
                                        })
                                        .catch((err) => {
                                            console.log(err)
                                        })
                                } else {
                                    this.setState({ "visa_id": "" })
                                    this.setState({ isRequiredDoc: false })
                                    this.setState({ isUploadDoc: false })
                                }




                            })
                            .catch((err) => {
                                console.log(err)
                            })



                    }

                })
                .catch((err) => {
                    console.log(err)
                })

        }).catch((error) => {
            console.log(error);
        });

        axios
            .get('/brule-engine/getOriginCountries?host=' + localStorage.getItem('host'))
            .then(res => {
                // console.log(res.data.dataobj.data);
                this.setState({ origin_country: res.data.dataobj.data })
            })
            .catch((err) => {
                console.log(err)
            })

        //getNationalities
        axios
            .get('/brule-engine/getNationalities?host=' + localStorage.getItem('host'))
            .then(res => {
                // console.log(res);
                this.setState({ nationalityArr: res.data.dataobj.data })
            })
            .catch((err) => {
                console.log(err)
            })
        // axios
        //     .get('/brule-engine/getSupportedCurrencies?host='+localStorage.getItem("host"))
        //     .then(res => {
        //          console.log(res.data.dataobj.data);
        //          this.setState({supported_currency:res.data.dataobj.data})
        //     })
    }

    handleTravelDateRange = (momentDate) => {
        // console.log(momentDate);
        // console.log("arrival_dt " + momentDate[0]._d)
        // console.log("departure_dt " + momentDate[1]._d)
        // console.log((new Date( momentDate[1]._d ).getTime() - new Date(momentDate[0]._d).getTime() ) / (60 * 60 * 24 * 1000));
        this.setState({ difference: (new Date(momentDate[1]._d).getTime() - new Date(momentDate[0]._d).getTime()) / (60 * 60 * 24 * 1000) })
        // this.setState({journey_start_date: date})
        // console.log(this.state.journey_start_date)
        this.setState({ journey_start_date: momentDate[0]._d, journey_end_date: momentDate[1]._d, isRequiredDoc: false, isUploadDoc: false, defaultChecked: false, card_input: '', visa_id: '', })
    }

    arrival = ""
    handleArrivalDate = (date) => {
        // console.log(e.target.value)
        this.setState({
            isError: false,
            ErrorMsg: ""
        })
        this.setState({ journey_start_date: date })
        // console.log(this.state.journey_start_date)
        let monthNames = ["Jan", "Feb", "Mar", "Apr",
            "May", "Jun", "Jul", "Aug",
            "Sep", "Oct", "Nov", "Dec"];

        var dt = new Date(date);
        var datestr = dt.getDate() + '-' + monthNames[(dt.getMonth())] + '-' + dt.getFullYear()
        // console.log(date)
        // console.log(datestr)
        //localStorage.setItem('journey_start_date', datestr);
        this.setState({ journey_start_date: date })
        // console.log("Arrival Date =>" ,  this.state.journey_start_date);
        this.arrival = new Date(date).getTime()
        // console.log(new Date(date).getTime());

        var diff = ((new Date(this.state.journey_end_date).getTime()) - this.arrival) / (60 * 60 * 24 * 1000)
        // console.log(diff);
        this.setState({ difference: diff })
    }


    departure = ""
    handleDepartureDate = (date) => {
        // this.setState({journey_end_date: date})
        this.setState({
            isError: false,
            ErrorMsg: ""
        })
        let monthNames = ["Jan", "Feb", "Mar", "Apr",
            "May", "Jun", "Jul", "Aug",
            "Sep", "Oct", "Nov", "Dec"];

        var dt = new Date(date);
        var datestr = dt.getDate() + '-' + monthNames[(dt.getMonth())] + '-' + dt.getFullYear()
        // console.log(date)
        // console.log(datestr)
        //localStorage.setItem('journey_end_date', datestr);
        this.setState({ journey_end_date: date })
        // console.log("Departure Date=>" , this.state.journey_end_date);
        this.departure = new Date(date).getTime()
        // console.log(new Date(date).getTime());
        var diff = (this.departure - (new Date(this.state.journey_start_date).getTime())) / (60 * 60 * 24 * 1000)
        // console.log(diff);
        this.setState({ difference: diff })
    }


    // difference  = (this.departure -  this.arrival) / (3600 * 24 * 1000)




    handleOptionChange(event) {
        // console.log(event.target.value)
        this.setState({ selected_currency: event.target.value })
        localStorage.setItem('base_currency_symbol', event.target.value)
        this.api_visaOffers()

    }
    handleDeleteIconClick = card => {
        // console.log("delete clicked")
        this.setState({
            showDeleteModall: !this.state.showDeleteModall,
            cardToDelete: card
        })
    }
    deleteToggle = () => {
        this.setState({ showDeleteModall: !this.state.showDeleteModall })
    }
    handleModalDeleteClick = () => {
        this.setState({ showDeleteModall: !this.state.showDeleteModall })
        var card = this.state.cardToDelete
        let filteredArray = this.state.uploadedDoc.filter(item => item.file_name !== card.file_name)
        this.setState({ uploadedDoc: filteredArray });
    }

    api_visaOffers() {
        axios
            .post('/visa/getVisaOffers', {
                "travelling_to_identity": localStorage.getItem('travelling_to_identity'),
                "host": localStorage.getItem('host')
            },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
            .then((res) => {
                // console.log( "resp====>", res.data.data)
                if (res.data.dataobj === undefined) {
                    //console.log("undefined resp");
                    this.setState({ showSupportedCur: false })
                } else {
                    this.setState({ showSupportedCur: true })
                }

                this.setState({ visa_id: '' })
                //this.setState({visaOffer: res.data.dataobj.visa})
                if (res.data.data == "success") {
                    var activeTouristObj = this.getActiveVisa(res.data.dataobj.visa[0].tourist)
                    var activeBusinessObj = this.getActiveVisa(res.data.dataobj.visa[1].business)
                    var activeStudentObj = this.getActiveVisa(res.data.dataobj.visa[2].student)
                    var activeTransitObj = this.getActiveVisa(res.data.dataobj.visa[3].transit)

                    this.setState({ supported_currency: res.data.dataobj.supported_currencies })

                    var current_currency = localStorage.getItem("base_currency_symbol")

                    var supp_cur_arr = res.data.dataobj.supported_currencies
                    if (supp_cur_arr.indexOf(localStorage.getItem('base_currency_symbol')) >= 0) {
                        console.log("current currency valid")
                        this.setState({ selected_currency: localStorage.getItem('base_currency_symbol') })
                    } else {
                        localStorage.setItem("base_currency_symbol", supp_cur_arr[0])
                        this.setState({ selected_currency: supp_cur_arr[0] })
                    }

                    // if (activeTouristObj[0].visa.length > 0) {
                    //     var found = false
                    //     for (var key in activeTouristObj[0].visa[0].fees) {
                    //         if (key == current_currency) {
                    //             found = true
                    //             localStorage.setItem("base_currency_symbol", current_currency)
                    //             this.setState({ selected_currency: current_currency })
                    //             break;
                    //         }
                    //     }
                    //     if (!found) {
                    //         for (var key in activeTouristObj[0].visa[0].fees) {
                    //             console.log(">>> " + key)
                    //             localStorage.setItem("base_currency_symbol", key)
                    //             this.setState({ selected_currency: key })
                    //             break;
                    //         }
                    //     }

                    // } else if (activeBusinessObj[0].visa.length > 0) {
                    //     var found = false
                    //     for (var key in activeBusinessObj[0].visa[0].fees) {
                    //         if (key == current_currency) {
                    //             found = true
                    //             localStorage.setItem("base_currency_symbol", current_currency)
                    //             this.setState({ selected_currency: current_currency })
                    //             break;
                    //         }
                    //     }
                    //     if (!found) {
                    //         for (var key in activeBusinessObj[0].visa[0].fees) {
                    //             console.log(">>> " + key)
                    //             localStorage.setItem("base_currency_symbol", key)
                    //             this.setState({ selected_currency: key })
                    //             break;
                    //         }
                    //     }
                    // } else if (activeStudentObj[0].visa.length > 0) {
                    //     var found = false
                    //     for (var key in activeStudentObj[0].visa[0].fees) {
                    //         if (key == current_currency) {
                    //             found = true
                    //             localStorage.setItem("base_currency_symbol", current_currency)
                    //             this.setState({ selected_currency: current_currency })
                    //             break;
                    //         }
                    //     }
                    //     if (!found) {
                    //         for (var key in activeStudentObj[0].visa[0].fees) {
                    //             console.log(">>> " + key)
                    //             localStorage.setItem("base_currency_symbol", key)
                    //             this.setState({ selected_currency: key })
                    //             break;
                    //         }
                    //     }
                    // } else if (activeTransitObj[0].visa.length > 0) {
                    //     var found = false
                    //     for (var key in activeTransitObj[0].visa[0].fees) {
                    //         if (key == current_currency) {
                    //             found = true
                    //             localStorage.setItem("base_currency_symbol", current_currency)
                    //             this.setState({ selected_currency: current_currency })
                    //             break;
                    //         }
                    //     }
                    //     if (!found) {
                    //         for (var key in activeTransitObj[0].visa[0].fees) {
                    //             console.log(">>> " + key)
                    //             localStorage.setItem("base_currency_symbol", key)
                    //             this.setState({ selected_currency: key })
                    //             break;
                    //         }
                    //     }
                    // }


                    this.setState({ supported_currencies: res.data.dataobj.supported_currencies })
                    this.setState({ touristVisa: activeTouristObj })
                    this.setState({ businessVisa: activeBusinessObj })
                    this.setState({ studentVisa: activeStudentObj })
                    this.setState({ transitVisa: activeTransitObj })

                    if (this.state.touristVisa.length > 0) {
                        if (this.state.touristVisa[0].visa.length != 0) {
                            this.setState({ "visa_id": this.state.touristVisa[0].visa[0].visa_id })
                            this.setState({ visa_duration_type: this.state.touristVisa[0].visa[0].duration_type })
                            localStorage.setItem("visa_id", this.state.touristVisa[0].visa[0].visa_id)
                        } else {
                            // this.setState({ touristVisa: [] })
                            // this.setState({ businessVisa: [] })
                            // this.setState({ studentVisa: [] })
                            // this.setState({ transitVisa: [] })
                            this.api_visaDocuments("")
                        }

                        // this.setState({ "visa_id": this.state.touristVisa[0].visa[0].visa_id })
                        // localStorage.setItem("visa_id", this.state.touristVisa[0].visa[0].visa_id)

                        /* commenting below map block to solve VP-220 */

                        // activeTouristObj[0].visa.map((t_visa) => {
                        //     if (t_visa.visa_id === this.state.touristVisa[0].visa[0].visa_id) {
                        //         // console.log(t_visa.visa_id)
                        //         var visa_fees_struct = ""
                        //         // if(localStorage.getItem('base_currency_symbol') == "INR"){
                        //         //     visa_fees_struct = t_visa.fees.INR
                        //         // } else if(localStorage.getItem('base_currency_symbol') == "AED"){
                        //         //     visa_fees_struct = t_visa.fees.AED
                        //         // } else if(localStorage.getItem('base_currency_symbol') == "USD"){
                        //         //     visa_fees_struct = t_visa.fees.USD
                        //         // } else if(localStorage.getItem('base_currency_symbol') == "NGN"){
                        //         //     visa_fees_struct = t_visa.fees.NGN
                        //         // } 
                        //         visa_fees_struct = t_visa.fees[localStorage.getItem('base_currency_symbol')]
                        //         this.setState({ isError: false, showVisaofferError: false, showDocumentError: false, visa_id: t_visa.visa_id, visa_code: t_visa.visa_code, total_days: t_visa.duration_days, visa_fees: visa_fees_struct, visa_category: "tourist" })
                        //         this.api_visaDocuments(t_visa.visa_id)
                        //         // localStorage.setItem('visa_id',t_visa.visa_id)
                        //         // localStorage.setItem('visa_code',t_visa.visa_code)
                        //         // localStorage.setItem('total_days',t_visa.duration_days)
                        //     }
                        // })
                    } else {
                        this.setState({ "visa_id": "" })
                        this.setState({ isRequiredDoc: false })
                        this.setState({ isUploadDoc: false })
                    }


                } else {
                    this.setState({ touristVisa: [] })
                    this.setState({ businessVisa: [] })
                    this.setState({ studentVisa: [] })
                    this.setState({ transitVisa: [] })
                    this.api_visaDocuments("")
                }

            })
            .catch((err) => {
                console.log(err)
            })
    }
    getActiveVisa = (givenArray) => {
        var activeCategoryVisa = []
        var activeVisa = []
        var tourist = givenArray
        for (var index in tourist) {
            var activeVisa = []
            var visaOffer = tourist[index].visa
            var obj = ''
            for (var statusindex in visaOffer) {
                // console.log("*******")
                // console.log(visaOffer[statusindex].status)
                if (visaOffer[statusindex].status === 'active') {
                    // console.log("*******" + statusindex)
                    activeVisa.push(visaOffer[statusindex])
                }
            }
            obj = {
                "type": tourist[index].type,
                "option": tourist[index].option,
                "visa": activeVisa
            }
            activeCategoryVisa.push(obj)

        }
        // console.log(activeCategoryVisa)
        // console.log("*******///")
        return activeCategoryVisa
    }

    handleApplicantsChange(event) {
        this.setState({ applicants: event.target.value })
        localStorage.setItem("applicants", event.target.value)
    }

    capitalize(s) {
        if (typeof s !== 'string') return ''
        return s.charAt(0).toUpperCase() + s.slice(1)

    }

    handleCORChecked = () => {
        this.setState({
            cor_checked: !this.state.cor_checked,
            isError: false, showVisaofferError: false, showDocumentError: false
        })
        // console.log("Cor checked ===>" , this.state.cor_checked);
        corflag = !corflag
        // console.log("Cor corflag ===>" , corflag);
        if (corflag == true) {
            this.setState({ nationality: localStorage.getItem('origin'), defaultChecked: false })
            localStorage.setItem("nationality", localStorage.getItem('origin'))
            this.get_travelling_on_flag_change()
        }

    }
    get_travelling_on_flag_change() {
        axios
            .post('/brule-engine/getTravellingTo', {
                "origin": localStorage.getItem('origin'),//india
                "nationality": localStorage.getItem('nationality'),//india
                "host": localStorage.getItem('host')
            },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
            .then((res) => {
                // console.log(res)
                if (res.data.data === "success") {
                    this.setState({ travellingTo: res.data.dataobj.data })
                    this.setState({ travelling_to_identity: res.data.dataobj.data[0].identity })
                    localStorage.setItem("travelling_to_identity", res.data.dataobj.data[0].identity)
                    let travelling_To = res.data.dataobj.data[0].identity //ind_ind_uae
                    let destination = this.state.travellingTo.filter(destination => destination.identity == travelling_To)
                    this.setState({
                        travelling_to_country: res.data.dataobj.data[0].name,
                        travelling_to: res.data.dataobj.data[0].cioc,
                        travelling_to_identity: res.data.dataobj.data[0].identity,
                        isCORRequired:res.data.dataobj.data[0]?.cor_required
                    })

                    this.setState({ isTravellingTo: true })




                    axios
                        .post('/visa/getVisaOffers', {
                            "travelling_to_identity": this.state.travelling_to_identity,
                            "host": localStorage.getItem('host')
                        },
                            {
                                headers: {
                                    'Content-Type': 'application/json'
                                }
                            })
                        .then((res) => {
                            // console.log("VISAAAOFFERSSSS ==> " , res);
                            if (res.data.dataobj === undefined) {
                                //console.log("undefined resp");
                                this.setState({ showSupportedCur: false })
                            } else {
                                this.setState({ showSupportedCur: true })
                            }

                            // console.log(res.data.dataobj.visa[0].tourist)  
                            //this.setState({visaOffer: res.data.dataobj.visa})
                            var activeTouristObj = this.getActiveVisa(res.data.dataobj.visa[0].tourist)
                            var activeBusinessObj = this.getActiveVisa(res.data.dataobj.visa[1].business)
                            var activeStudentObj = this.getActiveVisa(res.data.dataobj.visa[2].student)
                            var activeTransitObj = this.getActiveVisa(res.data.dataobj.visa[3].transit)

                            var supp_cur_arr = res.data.dataobj.supported_currencies
                            if (supp_cur_arr.indexOf(localStorage.getItem('base_currency_symbol')) >= 0) {
                                console.log("current currency valid")
                                this.setState({ selected_currency: localStorage.getItem('base_currency_symbol') })
                            } else {
                                localStorage.setItem("base_currency_symbol", supp_cur_arr[0])
                                this.setState({ selected_currency: supp_cur_arr[0] })
                            }

                            // if (activeTouristObj[0].visa.length > 0) {
                            //     for (var key in activeTouristObj[0].visa[0].fees) {
                            //         console.log(">>> " + key)
                            //         localStorage.setItem("base_currency_symbol", key)
                            //         this.setState({ selected_currency: key })
                            //         break;
                            //     }
                            // } else if (activeBusinessObj[0].visa.length > 0) {
                            //     for (var key in activeBusinessObj[0].visa[0].fees) {
                            //         console.log(">>> " + key)
                            //         localStorage.setItem("base_currency_symbol", key)
                            //         this.setState({ selected_currency: key })
                            //         break;
                            //     }
                            // } else if (activeStudentObj[0].visa.length > 0) {
                            //     for (var key in activeStudentObj[0].visa[0].fees) {
                            //         console.log(">>> " + key)
                            //         localStorage.setItem("base_currency_symbol", key)
                            //         this.setState({ selected_currency: key })
                            //         break;
                            //     }
                            // } else if (activeTransitObj[0].visa.length > 0) {
                            //     for (var key in activeTransitObj[0].visa[0].fees) {
                            //         console.log(">>> " + key)
                            //         localStorage.setItem("base_currency_symbol", key)
                            //         this.setState({ selected_currency: key })
                            //         break;
                            //     }
                            // }


                            this.setState({ supported_currencies: res.data.dataobj.supported_currencies })
                            this.setState({ touristVisa: activeTouristObj })
                            this.setState({ businessVisa: activeBusinessObj })
                            this.setState({ studentVisa: activeStudentObj })
                            this.setState({ transitVisa: activeTransitObj })
                            this.setState({ supported_currency: res.data.dataobj.supported_currencies })

                            if (this.state.touristVisa.length > 0) {
                                // console.log(">>>> "+this.state.touristVisa[0].visa[0].visa_id)
                                this.setState({ "visa_id": this.state.touristVisa[0].visa[0].visa_id })
                                this.setState({ visa_duration_type: this.state.touristVisa[0].visa[0].duration_type })
                                localStorage.setItem("visa_id", this.state.touristVisa[0].visa[0].visa_id)

                                activeTouristObj[0].visa.map((t_visa) => {
                                    if (t_visa.visa_id === this.state.touristVisa[0].visa[0].visa_id) {
                                        // console.log(t_visa.visa_id)
                                        var visa_fees_struct = ""
                                        // if(localStorage.getItem('base_currency_symbol') == "INR"){
                                        //     visa_fees_struct = t_visa.fees.INR
                                        // } else if(localStorage.getItem('base_currency_symbol') == "AED"){
                                        //     visa_fees_struct = t_visa.fees.AED
                                        // } else if(localStorage.getItem('base_currency_symbol') == "USD"){
                                        //     visa_fees_struct = t_visa.fees.USD
                                        // } 
                                        visa_fees_struct = t_visa[localStorage.getItem('base_currency_symbol')]
                                        this.setState({ isError: false, showVisaofferError: false, showDocumentError: false, visa_id: t_visa.visa_id, visa_code: t_visa.visa_code, total_days: t_visa.duration_days, visa_fees: visa_fees_struct, visa_category: "tourist" })
                                        // localStorage.setItem('visa_id',t_visa.visa_id)
                                        // localStorage.setItem('visa_code',t_visa.visa_code)
                                        // localStorage.setItem('total_days',t_visa.duration_days)
                                    }
                                })
                                /* commenting below api integration to solve VP-223 */

                                // axios
                                //     .post('/visa/getVisaDocuments', {
                                //         "travelling_to_identity": this.state.travelling_to_identity,
                                //         "visa_id": this.state.touristVisa[0].visa[0].visa_id,
                                //         "host": localStorage.getItem('host')
                                //     },
                                //         {
                                //             headers: {
                                //                 'Content-Type': 'application/json'
                                //             }
                                //         })
                                //     .then((resp) => {
                                //         // console.log(resp.data.dataobj.required_documents)
                                //         this.setState({ requiredDocuments: resp.data.dataobj.required_documents })
                                //         this.setState({ isRequiredDoc: true })
                                //         this.setState({ isUploadDoc: true })
                                //     })
                                //     .catch((err) => {
                                //         console.log(err)
                                //     })
                            } else {
                                this.setState({ "visa_id": "" })
                                this.setState({ isRequiredDoc: false })
                                this.setState({ isUploadDoc: false })
                            }




                        })
                        .catch((err) => {
                            console.log(err)
                        })



                } else {
                    this.setState({ travellingTo: [] })
                    this.setState({ travelling_to_identity: '' })
                    localStorage.setItem("travelling_to_identity", '')
                }
                this.api_visaOffers()

            })
            .catch((err) => {
                console.log(err)
            })
    }

    handleCORChange(event) {
        // this.setState({[event.target.name] : event.target.value})

        event.preventDefault();
        let country_origin = this.state.origin_country.filter(cor => cor.name === event.target.value)
        // console.log("Country ==>" , country_origin);
        // console.log(country_origin[0].cioc)

        localStorage.setItem("origin", country_origin[0].name)
        this.setState({ origin_cioc: country_origin[0].name })
        this.setState({
            isOrigin: true,
            isError: false, showVisaofferError: false, showDocumentError: false, visa_id: "", card_input: '', defaultChecked: false, requiredDocuments: [], isRequiredDoc: false, isUploadDoc: false
        })

        // if (this.state.cor_checked) {
        //     this.setState({ nationality: country_origin[0].name })
        //     localStorage.setItem("nationality", country_origin[0].name)
        //     // alert(this.state.nationality)

        // }
        // this.get_travelling_on_flag_change()
        localStorage.setItem('travelling_to_identity', `${country_origin[0]?.cioc}_${this.state.nationality_cioc}_${this.state.travelling_to}`)
        this.api_visaOffers()

    }

    handleNationalityChange(event) {
        event.preventDefault();

        this.setState({
            cor_checked: false,
            isError: false, showVisaofferError: false, showDocumentError: false, visa_id: "", card_input: '', defaultChecked: false, requiredDocuments: [], isRequiredDoc: false, isUploadDoc: false
        })
        corflag = false

        let nationality_obj = this.state.nationalityArr.filter(nationality_obj => nationality_obj.name === event.target.value)
        // console.log("Nationality==>" , nationality_obj);
        // console.log(nationality_obj[0].cioc)
        localStorage.setItem("nationality", nationality_obj[0].name)
        this.setState({ nationality: nationality_obj[0].name , nationality_cioc: nationality_obj[0]?.cioc})
        this.setState({ isNationality: true })

        axios
            .post('/brule-engine/getTravellingTo', {
                "origin": localStorage.getItem('origin'),//india
                "nationality": localStorage.getItem('nationality'),//india
                "host": localStorage.getItem('host')
            },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
            .then((res) => {
                // console.log(">>>>>>",res)
                localStorage.setItem("travelling_to_identity", "")
                if (res.data.data === "success") {
                    this.setState({
                        travellingTo: res.data.dataobj.data,
                        travelling_to_identity: res.data.dataobj.data[0].identity
                    })
                    localStorage.setItem("travelling_to_identity", res.data.dataobj.data[0].identity)
                } else {
                    this.setState({ travellingTo: [] })
                }
                this.api_visaOffers()

            })
            .catch((err) => {
                console.log(err)
            })


    }

    handleTravellingToChange(event) {
        event.preventDefault();
        this.setState({})

        let travelling_To = event.target.value //ind_ind_uae
        let destination = this.state.travellingTo.filter(destination => destination.identity == travelling_To)
        localStorage.setItem("travelling_to_identity", destination[0]?.identity)
        localStorage.setItem("travelling_to_country", destination[0]?.name)
        localStorage.setItem('travellingToCioc', destination[0]?.cioc)
        this.setState({
            travelling_to_country: destination[0].name,
            travelling_to: destination[0].cioc,
            travelling_to_identity: event.target.value,
            isCORRequired:destination[0]?.cor_required
        })
        //localStorage.setItem('travelling_to', destination[0].name)

        // console.log(event.target.value)
        localStorage.setItem("travelling_to_identity", event.target.value)
        this.setState({
            isTravellingTo: true, isError: false, showVisaofferError: false, showDocumentError: false, visa_id: "", card_input: '', defaultChecked: false, requiredDocuments: [], isRequiredDoc: false, isUploadDoc: false
        })
        this.api_visaOffers()
    }

    handleVisaTypeChange(event) {
        //event.preventDefault();
        this.setState({ visa_id: '' })
        this.setState({ visa_type: event.target.value })
        this.setState({
            isVisaType: true,
            isError: false, showVisaofferError: false, showDocumentError: false
        })
        localStorage.setItem("visa_type", event.target.value)
        // if(event.target.value === "Express"){

        //     this.setState({defaultChecked : false})
        // }
        this.setState({ defaultChecked: false })
        this.api_visaDocuments("")
    }

    handleEntryTypeChange(event) {
        //event.preventDefault();
        this.setState({ visa_id: '' })
        this.setState({ entry_type: event.target.value })
        this.setState({
            isEntryType: true,
            isError: false, showVisaofferError: false, showDocumentError: false,
        })
        this.setState({ defaultChecked: false })

        localStorage.setItem("entry_type", event.target.value)
        this.api_visaDocuments("")

        // axios
        //     .post('/visa/getVisaOffers',{
        //         "travelling_to_identity": this.state.travelling_to_identity
        //     },
        //     {
        //         headers : {
        //             'Content-Type' : 'application/json'
        //         }
        //     })
        //     .then((res) => {
        //         console.log(res.data.dataobj.visa[0].tourist)  
        //         this.setState({visaOffer: res.data.dataobj.visa})
        //         this.setState({touristVisa: res.data.dataobj.visa[0].tourist})
        //         this.setState({businessVisa: res.data.dataobj.visa[1].business})
        //         this.setState({studentVisa: res.data.dataobj.visa[2].student})
        //         this.setState({transitVisa: res.data.dataobj.visa[3].Transit})
        //     })
        //     .catch((err) => {
        //         console.log(err)
        //     })

        // axios
        //     .post('/visa/getVisaDocuments',{
        //         "travelling_to_identity": this.state.travelling_to_identity
        //     },
        //     {
        //         headers : {
        //             'Content-Type' : 'application/json'
        //         }
        //     })
        //     .then((resp) => {
        //         console.log(resp.data.dataobj.required_documents)
        //         this.setState({requiredDocuments: resp.data.dataobj.required_documents})
        //         this.setState({isRequiredDoc: true})
        //         this.setState({isUploadDoc: true})
        //     })
        //     .catch((err) => {
        //         console.log(err)
        //     })
    }

    handleVisaOfferChange(event, visa_id, _card = {}) {
        //  console.log("event", event , visa_id);
         console.log("Card =>",_card);
        let selected_card = { ..._card, journey_start_date: this.state.journey_start_date, journey_end_date: this.state.journey_end_date, visa_currency: this.state.selected_currency }
        localStorage.setItem('selected_visa_offer', JSON.stringify(selected_card))


        this.api_visaDocuments(visa_id)
        this.state.touristVisa.map((tourist_visa) => {
            tourist_visa.visa.map((t_visa) => {
                if (t_visa.visa_id === event.target.value) {
                    // console.log(t_visa.visa_id)
                    var visa_fees_struct = ""
                    // if(localStorage.getItem('base_currency_symbol') == "INR"){
                    //     visa_fees_struct = t_visa.fees.INR
                    // } else if(localStorage.getItem('base_currency_symbol') == "AED"){
                    //     visa_fees_struct = t_visa.fees.AED
                    // } else if(localStorage.getItem('base_currency_symbol') == "USD"){
                    //     visa_fees_struct = t_visa.fees.USD
                    // } 
                    visa_fees_struct = t_visa[localStorage.getItem('base_currency_symbol')]
                    this.setState({ isError: false, showVisaofferError: false, showDocumentError: false, selected_visa_type: t_visa.visa_type, visa_id: t_visa.visa_id, visa_duration_type: t_visa.duration_type, visa_code: t_visa.visa_code, total_days: t_visa.duration_days, visa_fees: visa_fees_struct, visa_category: "tourist" })
                    // localStorage.setItem('visa_id',t_visa.visa_id)
                    // localStorage.setItem('visa_code',t_visa.visa_code)
                    // localStorage.setItem('total_days',t_visa.duration_days)
                }
            })
        })

        this.state.businessVisa.map((business_visa) => {
            business_visa.visa.map((b_visa) => {
                if (b_visa.visa_id === event.target.value) {
                    // console.log(b_visa.visa_id)
                    var visa_fees_struct = ""
                    // if(localStorage.getItem('base_currency_symbol') == "INR"){
                    //     visa_fees_struct = b_visa.fees.INR
                    // } else if(localStorage.getItem('base_currency_symbol') == "AED"){
                    //     visa_fees_struct = b_visa.fees.AED
                    // } else if(localStorage.getItem('base_currency_symbol') == "USD"){
                    //     visa_fees_struct = b_visa.fees.USD
                    // } 
                    visa_fees_struct = b_visa.fees[localStorage.getItem('base_currency_symbol')]
                    this.setState({ isError: false, showVisaofferError: false, showDocumentError: false, selected_visa_type: b_visa.visa_type, visa_id: b_visa.visa_id, visa_duration_type: b_visa.duration_type, visa_code: b_visa.visa_code, total_days: b_visa.duration_days, visa_fees: visa_fees_struct, visa_category: "business" })
                    // localStorage.setItem('visa_id',b_visa.visa_id)
                    // localStorage.setItem('visa_code',b_visa.visa_code)
                    // localStorage.setItem('total_days',b_visa.duration_days)
                }
            })
        })

        this.state.studentVisa.map((student_visa) => {
            student_visa.visa.map((s_visa) => {
                if (s_visa.visa_id === event.target.value) {
                    // console.log(s_visa.visa_id)
                    var visa_fees_struct = ""
                    // if(localStorage.getItem('base_currency_symbol') == "INR"){
                    //     visa_fees_struct = s_visa.fees.INR
                    // } else if(localStorage.getItem('base_currency_symbol') == "AED"){
                    //     visa_fees_struct = s_visa.fees.AED
                    // } else if(localStorage.getItem('base_currency_symbol') == "USD"){
                    //     visa_fees_struct = s_visa.fees.USD
                    // } 
                    visa_fees_struct = s_visa.fees[localStorage.getItem('base_currency_symbol')]
                    this.setState({ isError: false, showVisaofferError: false, showDocumentError: false, selected_visa_type: s_visa.visa_type, visa_id: s_visa.visa_id, visa_duration_type: s_visa.duration_type, visa_code: s_visa.visa_code, total_days: s_visa.duration_days, visa_fees: visa_fees_struct, visa_category: "student" })
                    // localStorage.setItem('visa_id',s_visa.visa_id)
                    // localStorage.setItem('visa_code',s_visa.visa_code)
                    // localStorage.setItem('total_days',s_visa.duration_days)
                }
            })
        })

        this.state.transitVisa.map((transit_visa) => {
            transit_visa.visa.map((transit_Visa) => {
                if (transit_Visa.visa_id === event.target.value) {
                    // console.log(transit_Visa.visa_id)
                    var visa_fees_struct = ""
                    // if(localStorage.getItem('base_currency_symbol') == "INR"){
                    //     visa_fees_struct = transit_Visa.fees.INR
                    // } else if(localStorage.getItem('base_currency_symbol') == "AED"){
                    //     visa_fees_struct = transit_Visa.fees.AED
                    // } else if(localStorage.getItem('base_currency_symbol') == "USD"){
                    //     visa_fees_struct = transit_Visa.fees.USD
                    // } 
                    visa_fees_struct = transit_Visa.fees[localStorage.getItem('base_currency_symbol')]
                    this.setState({ isError: false, showVisaofferError: false, showDocumentError: false, selected_visa_type: transit_Visa.visa_type, visa_id: transit_Visa.visa_id, visa_duration_type: transit_Visa.duration_type, visa_code: transit_Visa.visa_code, total_days: transit_Visa.duration_days, visa_fees: visa_fees_struct, visa_category: "transit" })
                    // localStorage.setItem('visa_id',transit_Visa.visa_id)
                    // localStorage.setItem('visa_code',transit_Visa.visa_code)
                    // localStorage.setItem('total_days',transit_Visa.duration_days)
                }
            })
        })

    }

    handleOrganizeApplication() {
        if (this.state.travellingTo.length === 0 || this.state.travelling_to_identity === '') {
            this.setState({
                isError: true,
                ErrorMsg: "Travelling to routes are not available please select different country"
            })
            return
        }
        if (this.state.journey_start_date.getTime() === this.state.journey_end_date.getTime()) {
            this.setState({
                isError: true,
                ErrorMsg: "Arrival and Departure date should not be the same"
            })
            return
        }
        if (this.state.journey_start_date.getTime() > this.state.journey_end_date.getTime()) {
            this.setState({
                isError: true,
                ErrorMsg: "Arrival date should be earlier than Departure date"
            })
            return
        }
        if (this.state.visa_id === '') {
            //alert('Please select visa offer')
            this.setState({ showVisaofferError: true })
            return
        }
        if (this.state.requiredDocuments.length < 1) {
            this.setState({
                isError: true,
                ErrorMsg: "Required docs are not available please select different visa offer"
            })

            return
        }
        if (this.state.uploadedDoc.length < 1) {
            this.setState({ showDocumentError: true })
            return
        }

        this.showLoader()
        axios
            .post("/visa/createApplicationWithDocuments", {
                "user_id": localStorage.getItem('user_id'),
                "nationality": this.state.nationality,
                "travelling_to": this.state.travelling_to,
                "origin": this.state.origin_cioc,
                "travelling_to_country": this.state.travelling_to_country,
                "travelling_to_identity": this.state.travelling_to_identity,
                "supported_currencies": this.state.supported_currencies,
                "visa_id": this.state.visa_id,
                "duration_type": this.state.visa_duration_type,
                "visa_code": this.state.visa_code,
                "visa_category": this.state.visa_category,
                "visa_fees": this.state.visa_fees,
                "total_days": this.state.total_days,
                "base_currency_symbol": localStorage.getItem('base_currency_symbol'),
                "journey_start_date": this.state.journey_start_date,
                "journey_end_date": this.state.journey_end_date,
                "documentsArray": this.state.uploadedDoc,
                "host": localStorage.getItem('host'),
                "visa_entry_type": this.state.entry_type,
                "visa_processing_type": this.state.visa_type,
                "user_type": "customer",
                "application_created_by_user": "customer_user",
                "visa_type": this.state.selected_visa_type,
            },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
            .then(res => {
                // console.log(res);
                res.data.dataobj.applicants.map((applicant) => {
                    this.setState({ applicant_id: applicant._id })
                    localStorage.setItem('applicant_id', applicant._id)
                })
                this.setState({ isOrganiseApplication: true })
                localStorage.setItem('application_id', res.data.dataobj._id)
                this.hideLoader();
            })
            .catch(err => {
                console.log(err);
            })
    }

    custom_Request = (options) => {
        this.setState({ showDocumentError: false, documentError: false })
        // console.log("Options" , options)  
        const data = new FormData();

        console.log(">>>>>>> " + options.file.name)
        console.log(">>> " + options.file.name.search(".JPG"))

        if ((options.file.name.search(".png") > 1) || (options.file.name.search(".PNG") > 1)) {
            data.append('document', options.file, options.file.name)
        } else if ((options.file.name.search(".jpg") > 1) || (options.file.name.search(".JPG") > 1)) {
            data.append('document', options.file, options.file.name)
        } else if ((options.file.name.search(".pdf") > 1) || (options.file.name.search(".PDF") > 1)) {
            data.append('document', options.file, options.file.name)
        } else if ((options.file.name.search(".jpeg") > 1) || (options.file.name.search(".JPEG") > 1)) {
            data.append('document', options.file, options.file.name)
        } else {
            this.setState({ documentError: true })
            return
        }



        const config = {
            "headers": {
                "content-type": 'multipart/form-data'
            }
        }

        axios
            .post("/process-documents/uploadAndExtractDocument", data, options.action, config)
            .then(res => {
                // console.log(res.data.dataobj);
                //this.setState({uploadedDoc: res.data.dataobj})
                var new_data = this.state.uploadedDoc.concat(res.data.dataobj)
                // console.log(new_data)

                new_data.map((uploaded_file) => {
                    // console.log(uploaded_file)
                })

                this.setState({ uploadedDoc: new_data })

                options.onSuccess(res)
            })
            .catch(e => {
                options.onError(e)
            })
    }

    doc_props = {
        name: 'file',
        multiple: true,
        showUploadList: false,
        customRequest: this.custom_Request,
        // url: 'http://192.168.1.16:3000/process-documents/uploadAndProcessDocument',
        // method: 'post',
        onChange(info) {
            // console.log("Info" , info)            
            const { status } = info.file;
            if (status !== 'uploading') {
                // console.log(info.file, info.fileList);
                //info.file.status = 'done'
                info.fileList.map((file) => {
                    if (file.error) {
                        // alert("not in correct format")
                    }
                })
            }
            if (status === 'done') {
                // message.success(`${info.file.name} file uploaded successfully.`);
            } else if (status === 'error') {
                // message.error(`${info.file.name} file upload failed.`);
            }
        },
    };

    uploadedDocCards = (card, index) => {
        // var cards = []
        // for(var i=0; i<this.state.uploadedDoc.length; i++){
        //     cards [i] = (
        //         <>
        // console.log( "IMAGE CArd===>" , card)

        // let fileFormat = false

        // if(card === undefined){
        //     fileFormat = true ;

        // }
        return (
            <>
                {/* {this.setState({showDocumentError : fileFormat})} */}
                {/* {fileFormat &&
                         <MDBAlert color='danger'>Please upload document in correct format.</MDBAlert>
                    } */}
                <MDBCol size="6" sm="12" md="2" lg="2" style={{ marginTop: "1rem" }}>
                    {/* {!fileFormat && */}
                    <MDBCard style={{ position: 'relative', boxShadow: "-2px 2px 13px 0 hsla(0,0%,82.4%,.3)", border: ".5px solid #f0f0f0" }} className="card-input text-center mb-4 shadow-sm">
                        <img className="img-fluid icon-actions bg-white p-2 shadow fixed-bottom" onClick={() => this.handleDeleteIconClick(card)} style={{ position: 'absolute', bottom: 0, left: 0, backgroundColor: 'white', zIndex: "0" }} src={delete_icon} />
                        {/* } */}


                        {/* <img className="img-fluid icon-actions" data-toggle="modal" data-target="#imgModal"  style={{position:'absolute', bottom:0, left:35,backgroundColor:'white'}} src={zoom_icon} />   */}
                        {/* 
                    <img className="img-fluid icon-actions" style={{position:'absolute', bottom:0, left:25,backgroundColor:'white'}} src={edit_icon} /> 
                    <img className="img-fluid icon-actions" style={{position:'absolute', bottom:0, left:50,backgroundColor:'white'}} src={move_icon} /> 
                */}
                        {/* {!fileFormat && */}

                        <img className="p-2 img-fluid " style={{ width: '100%', height: '200px', objectFit: "contain" }} src={card.file} onError={(e) => { e.target.onerror = null; e.target.src = card.file }}></img>
                    </MDBCard>
                    {/* } */}
                </MDBCol>

            </>
        );
        //}
        // return cards
    }





    handleDetails = (card) => {
        // console.log( "OFFER CARD" , card );

        var currency = ""

        currency = localStorage.getItem('base_currency_symbol')
        // console.log("CURRENCY" , currency);

        var fees = card.fees[currency].adult_govt_fee
        // console.log("FEES =>" , fees );
        var visaero_fee = card.fees[currency].adult_service_fee
        // console.log("Visareo FEE =>" , visaero_fee );

        var tax_percent = ""
        var tax_name = ""

        let taxes = []

        card.fees[currency].additional_taxes.map((tax) => {
            tax_percent = tax.tax_percentage
            tax_name = tax.tax_type
            // tax_amount =  visaero_fee * ( parseFloat(tax_percent)  /100)
            taxes.push({
                tax_amount: visaero_fee * (parseFloat(tax_percent) / 100),
                taxname: tax_name,
                taxpercent: tax_percent
            }
            )
        })

        this.setState({ additionalTaxes: taxes })

        var taxamount = taxes.map((tax) => { return (tax.tax_amount) }).reduce((a, b) => a + b, 0)

        var total_amount = Math.round(parseFloat(fees) + parseFloat(taxamount) + parseFloat(visaero_fee));
        // console.log("Total Amount" , (total_amount));

        var some_message = card.desc.body;
        var detail_message = card.desc.header;
        // console.log("Detail MEssage => " , detail_message);

        this.setState({
            adultFee: fees, visaeroFee: visaero_fee, someMessage: some_message,
            totalAmount: total_amount, currencyType: currency, detailMessage: detail_message
        })


    }

    api_visaDocuments(visaid) {

        // console.log("CArd123===>", visaid);
        this.setState({
            card_input: 'card-input',
            isError: false, showVisaofferError: false, showDocumentError: false, visa_id: visaid
        })

        axios
            .post('/visa/getVisaDocuments', {
                "travelling_to_identity": this.state.travelling_to_identity,
                "visa_id": visaid,
                "host": localStorage.getItem('host')
            },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
            .then((resp) => {
                //  console.log("Resp==>", resp);
                if (resp.data.data === "success") {

                    // console.log(resp.data.dataobj.required_documents)

                    this.setState({ requiredDocuments: resp.data.dataobj.required_documents })
                    this.setState({ isRequiredDoc: true })
                    this.setState({ isUploadDoc: true })
                    if (resp.data.dataobj.required_documents.length === 0) {
                        this.setState({ isUploadDoc: false, isRequiredDoc: false, uploadedDoc: [] })
                    }
                } else if (resp.data.data === "error") {
                    this.setState({ requiredDocuments: [] })
                    this.setState({ isRequiredDoc: false })
                    this.setState({ isUploadDoc: false })
                }

            })
            .catch((err) => {
                console.log(err)
            })
    }

    offerCards = (card, index) => {
        // console.log("CArds123===>", card);
        // console.log("this.state.defaultChecked===>", this.state.defaultChecked);
        // console.log("visaflag===>", visaflag);
        var fees = 0
        // if(localStorage.getItem('base_currency_symbol') == "INR"){
        //     if(card.fees.INR) {fees = card.fees.INR.adult_govt_fee}
        // } else if(localStorage.getItem('base_currency_symbol') == "AED"){
        //     if(card.fees.AED) {fees = card.fees.AED.adult_govt_fee}
        // } else if(localStorage.getItem('base_currency_symbol') == "USD"){
        //     if(card.fees.USD) {fees = card.fees.USD.adult_govt_fee}
        // } else if(localStorage.getItem('base_currency_symbol') == "NGN"){
        //     if(card.fees.NGN) {fees = card.fees.NGN.adult_govt_fee}
        // } 
        let selCur = card.fees[localStorage.getItem('base_currency_symbol')]
        var total_tax = 0
        for (var i = 0; i < selCur.additional_taxes.length; i++) {
            total_tax = total_tax + ((parseInt(selCur.additional_taxes[i].tax_percentage) / 100) * parseInt(selCur.adult_service_fee))
        }
        fees = Math.round(parseInt(selCur.adult_govt_fee) + parseInt(selCur.adult_service_fee) + total_tax)
        let isChecked = false
        if (this.state.defaultChecked && card.category == "tourist" && index == 0 && card.type == "Standard" && card.option == "Single") {

            // if (card.category == "tourist" && index == 0 && card.type == "Standard") {
            isChecked = true
            // }
        }

        var displayCard = true
        if (card.duration_type === "hours") {
            var Days = Math.round(card.duration_days / 24);
            //var Remainder = (card.duration_days % 24);
            //var Hours = Math.floor(Remainder);
            //console.log("Days " + Days, "hours " + Hours, this.state.difference)
            if (this.state.difference > Days) {
                displayCard = false
            }
        }
        if (this.state.difference > (card.duration_days)) {
            displayCard = false
        }

        return (
            <>

                <MDBCol size="12" sm="3" lg="3" >
                    <label  >
                        {
                            displayCard &&
                            <input type="radio" defaultChecked={isChecked} id="offers" name="offer" key={index} className={this.state.card_style} value={card.visa_id} onClick={(e) => this.handleVisaOfferChange(e, card.visa_id, card)} />
                        }

                        <MDBCard style={{ zIndex: "0", position: 'relative', backgroundColor: displayCard ? "" : "#f0f0f0", opacity: displayCard ? "" : "0.5" }} className={this.state.card_input + " mt-3 mb-1"}    >
                            {card.visa_id !== this.state.visa_id ? (<div className="unchecked"></div>) : (<div className="unchecked"></div>)}
                            {card.visa_type === "evisa" &&
                                (displayCard ?
                                    <img style={{ position: 'absolute', top: -13, left: -21 }} className="ribbon" src={localStorage.getItem("host") === "visaero" ? visaero_evisa_img : evisa_img} />
                                    : <img style={{ position: 'absolute', top: -13, left: -21 }} className="ribbon" src={disable_evisa} />)
                            }
                            {(card.visa_type === "visa" || card.visa_type === "normal") &&
                                (displayCard ?
                                    <img style={{ position: 'absolute', top: -13, left: -21 }} className="ribbon" src={localStorage.getItem('host') === "visaero" ? visaero_visa_img : visa_img} />
                                    : <img style={{ position: 'absolute', top: -13, left: -21 }} className="ribbon" src={disable_visa} />)
                            }
                            <MDBCardBody className="text-left">
                                {/* <p style={{color:'grey'}}>Total Cost</p>
                             */}
                                {"\n"}
                                {/* <MDBTypography tag='h2' variant="h2-responsive" className="font-weight-bold">{localStorage.getItem('base_currency_symbol')} {fees}</MDBTypography> */}
                                <h3 className="font-weight-bold">{localStorage.getItem('base_currency_symbol')} {fees}</h3>
                                <h5>{card.duration_display}</h5>
                                <small className="text-muted">{card.desc.sub_header_1}</small><br />
                                <small className="text-muted">{card.desc.sub_header_2}</small><br />
                                <small className="text-muted">{card.desc.sub_header_3}</small><br />
                                <div className="mt-2">
                                    {displayCard ?
                                        <MDBBtn color="none" data-toggle="modal" style={{ border: `2px solid ${this.state.brand_color}` }} className="btn  text-capitalize shadow-none m-0 pt-2 pb-2 pl-4 pr-4" data-target="#visaOfferModal" onClick={() => (this.handleDetails(card))} >Details</MDBBtn>
                                        : <MDBBtn color="none" className="btn btn-outline-dark text-capitalize shadow-none m-0 pt-2 pb-2 pl-4 pr-4" disabled   >Details</MDBBtn>
                                    }
                                </div>
                            </MDBCardBody>
                        </MDBCard>
                    </label>
                </MDBCol>

            </>
        );


    }

    requiredDocs = (card, index) => {
        // console.log(card);
        return (
            <MDBCol sm="6" lg="3" >
                <MDBRow className={index == 0 ? " " : "border-left"} >
                    <p className="mb-2"> <img src={document_icon} className="mr-2 ml-3" /> {card.doc_display_name} <img className="info-icon ml-4" src={info} data-toggle="modal" data-target="#infoModal" onClick={() => this.setState({ modalText: card.doc_description })} /></p>
                    {/* <MDBCol size="9"><p><img style={{paddingBottom:'1%'}} src={document_icon} className="float-left" /><div className="pl-2 pr-4">{card.doc_display_name}</div> </p></MDBCol>
                    <MDBCol size="3" ><img className="info-icon float-right" src={info} data-toggle="modal" data-target="#infoModal" onClick={()=> this.setState({modalText : card.doc_description})} /></MDBCol> */}
                </MDBRow>
            </MDBCol>
        );
    }

    render() {

        // console.log("Difference>>>>>>>>>>" , this.difference);

        const stepsIcon = () => {
            return <MDBIcon far icon="comment-alt" />
        }

        if (this.state.isOrganiseApplication) {
            return <Redirect to="/new-visa/organize" />
        }

        if (this.state.loading) {
            // console.log(this.state.loading)
            return (
                <div className="w-100 h-100 position-fixed left-0 right-0 top-0 bottom-0 d-flex align-items-center justify-content-center loader flex-column text-white">
                    <img style={{ height: "80%", objectFit: "contain", width: "50%" }} src={loader} alt="loading..." />
                    {/* <p>Extracting data from documents.</p>
                <p>Creating Applicants</p>
                <p>Processing Applicants</p>  */}
                </div>
            )
            //  <MDBRow>
            //     <MDBCol size="12" sm="4" lg="4"></MDBCol>
            //     <MDBCol size="12" sm="4" lg="4">
            //         <div style={{ height: "80vh" }}>
            //             <img src={loader} alt="loading..." height="70%" style={{ marginTop: "180px" , objectFit : "contain" , width :"50%" }} />
            //         </div>
            //     </MDBCol>
            //     <MDBCol size="12" sm="4" lg="4"></MDBCol>
            // </MDBRow>


        }


        var no_tourist = <p style={{ marginBottom: '1rem', marginTop: '1rem' }}>No visa offers for Tourist</p>
        var no_business = <p style={{ marginBottom: '1rem', marginTop: '1rem' }}>No visa offers for Business</p>
        var no_student = <p style={{ marginBottom: '1rem', marginTop: '1rem' }}>No visa offers for Students</p>
        var no_transit = <p style={{ marginBottom: '1rem', marginTop: '1rem' }}>No visa offers for Transit</p>

        this.state.touristVisa.map((tourist_visa) => {
            if (tourist_visa.type === this.state.visa_type && tourist_visa.option === this.state.entry_type) {
                no_tourist = ""
            }
        })

        this.state.businessVisa.map((business_visa) => {
            if (business_visa.type === this.state.visa_type && business_visa.option === this.state.entry_type) {
                no_business = ""
            }
        })

        this.state.studentVisa.map((student_visa) => {
            if (student_visa.type === this.state.visa_type && student_visa.option === this.state.entry_type) {
                no_student = ""
            }
        })

        this.state.transitVisa.map((transit_visa) => {
            if (transit_visa.type === this.state.visa_type && transit_visa.option === this.state.entry_type) {
                no_transit = ""
            }
        })

        const dateFormat = 'DD/MM/YYYY';
        const monthFormat = 'YYYY/MM';

        const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY'];

        const customFormat = value => `custom format: ${value.format(dateFormat)}`;

        const disabledDate = (current) => {
            // Can not select days before today and today
            return current && current < moment().endOf('day');
        }

        return (
            <>
                <div>

                    <h4><b>Apply New Visa</b></h4>
                </div>
                <div className="mt-2">
                    <MDBCard style={{ boxShadow: "-2px 2px 13px 0 hsla(0,0%,82.4%,.3)", border: ".5px solid #f0f0f0" }}>
                        <MDBCardBody>
                            <MDBCardTitle>Basic Information</MDBCardTitle>
                            <hr />
                            <MDBRow>
                                {/* <MDBCol size='12' sm='6' md='4' lg='4' xl='4' style={{display:'none'}}>
                                    <small>Nationality</small>
                                    <Select
                                        id="origin"
                                        style={{ width: '100%', textAlign: 'left', padding: 0 }}
                                        name="origin_cioc"
                                        onChange={this.handleCORChange}
                                        value={this.state.origin_cioc}
                                    >
                                        {this.state.origin_country.map((cor) =>
                                            <MenuItem value={cor.name} key={cor.name}>{cor.name}</MenuItem>//<img src={cor.flag} id={styles.flag_Thumbnail} />
                                        )
                                        }
                                    </Select>
                                </MDBCol> */}
                                <MDBCol size='12' sm='6' md='4' lg='4' xl='4'>
                                    <MDBRow>
                                        <MDBCol sm='12' lg='6'><small>Nationality</small></MDBCol>
                                        {/* <MDBCol sm='12' lg='6' className="text-right">
                                            <div className="custom-control custom-checkbox">
                                                <input type="checkbox" checked={this.state.cor_checked} onChange={this.handleCORChecked} />
                                                <small className="pb-1" > Same as COR</small>
                                            </div>
                                        </MDBCol> */}
                                    </MDBRow>
                                    <Select
                                        id="nationality"
                                        style={{ width: '100%', textAlign: 'left', padding: 0 }}
                                        name="nationality"
                                        onChange={this.handleNationalityChange}
                                        value={this.state.nationality}
                                    >
                                        {this.state.nationalityArr.map((nationalities) =>
                                            <MenuItem value={nationalities.name} key={nationalities.name}>{nationalities.name}</MenuItem>
                                        )
                                        }
                                    </Select>
                                </MDBCol>
                                <MDBCol size='12' sm='6' md='6' lg='4' xl="4">
                                    <small>Traveling to</small>
                                    <Select
                                        id="travelling_to_identity"
                                        style={{ width: '100%', textAlign: 'left', padding: 0 }}
                                        name="travelling_to_identity"
                                        onChange={this.handleTravellingToChange}
                                        value={this.state.travelling_to_identity}
                                    >
                                        {this.state.travellingTo.map((travelling_to_identity, index) =>
                                            <MenuItem value={travelling_to_identity.identity} key={travelling_to_identity.name}>{travelling_to_identity.name}</MenuItem>
                                        )
                                        }
                                    </Select>
                                </MDBCol>
                                {this.state.isCORRequired && 
                                <MDBCol size='12' sm='6' md='6' lg='4' xl="4">
                                    <small>Country of Origin(COR)</small>
                                    <Select
                                        id="origin"
                                        style={{ width: '100%', textAlign: 'left', padding: 0 }}
                                        name="origin_cioc"
                                        onChange={this.handleCORChange}
                                        value={this.state.origin_cioc}
                                    >
                                        {this.state.origin_country.map((cor) =>
                                            <MenuItem value={cor.name} key={cor.name}>{cor.name}</MenuItem>//<img src={cor.flag} id={styles.flag_Thumbnail} />
                                        )
                                        }
                                    </Select>
                                </MDBCol>
                                        }
                                {/* <MDBCol size='12' sm='6' md='6' lg='3' style={{width:'100%'}}>
                                    <small>Applicants</small><br/>
                                        <TextField 
                                            id="applicants" 
                                            type="number"
                                            name="applicants"
                                            onChange={this.handleApplicantsChange}
                                            value={this.state.applicants}
                                        />
                                </MDBCol> */}
                            </MDBRow>
                        </MDBCardBody>
                    </MDBCard>
                </div>
                {(this.state.isOrigin && this.state.isNationality && this.state.isTravellingTo) &&
                    <div className="row">
                        <div className=" mt-4 col-lg-4 ">
                            <MDBCard style={{ boxShadow: "-2px 2px 13px 0 hsla(0,0%,82.4%,.3)", border: ".5px solid #f0f0f0" }}>
                                <MDBCardBody>
                                    <MDBCardTitle>Travel Dates</MDBCardTitle>
                                    <hr />
                                    <MDBRow>
                                        <MDBCol size="12" sm="12" md="12" lg="12">
                                            <Space direction="vertical" size={12}>

                                                <RangePicker
                                                    defaultValue={[moment(this.state.journey_start_date), moment(this.state.journey_end_date)]}
                                                    format={dateFormat}
                                                    onChange={this.handleTravelDateRange}
                                                    allowClear={false}
                                                    disabledDate={disabledDate}
                                                />
                                                {/* <DatePicker defaultValue={moment('2015/01/01', dateFormat)} format={customFormat} /> */}
                                            </Space>
                                        </MDBCol>
                                        {/* <MDBCol size="12" sm="6" md="6" lg="6"> */}
                                        {/* <TextField
                                            id="date"
                                            label="Arrival Date"
                                            type="date"
                                            defaultValue={dateFormat(new Date())}
                                            onChange={this.handleArrivalDate}
                                            className="mt-2"
                                        /> */}
                                        {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                        className="mb-0 mt-0"
                                            // disableToolbar
                                            variant="inline"
                                            format="dd/MM/yyyy"
                                            margin="normal"
                                            id="arrival-date"
                                            label="Arrival Date"
                                            value={this.state.journey_start_date}
                                            onChange={this.handleArrivalDate}
                                            autoOk
                                            disablePast
                                            minDate={ new Date()  }
                                            minDateMessage=""
                                            InputLabelProps={{
                                                shrink: true,
                                              }}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                        />
                                        </MuiPickersUtilsProvider>
                                    </MDBCol>
                                    <MDBCol size="12" sm="6" md="6" lg="6"> */}
                                        {/* <TextField
                                            id="date"
                                            label="Departure Date"
                                            type="date"
                                            defaultValue={dateFormat(new Date())}
                                            onChange={this.handleDepartureDate}
                                            className="mt-2"
                                        /> */}
                                        {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                        className="mb-0 mt-0"
                                            // disableToolbar
                                            variant="inline"
                                            format="dd/MM/yyyy"
                                            margin="normal"
                                            id="departure-date"
                                            label="Departure Date"
                                            value={this.state.journey_end_date}
                                            onChange={this.handleDepartureDate}
                                            autoOk
                                            minDate={new Date(this.state.journey_start_date) }
                                            disablePast
                                            minDateMessage="Departure Date can not be of the past."
                                            InputLabelProps={{
                                                shrink: true,
                                              }}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}

                                        />
                                        </MuiPickersUtilsProvider>
                                    </MDBCol>  */}

                                    </MDBRow>
                                </MDBCardBody>
                            </MDBCard>
                        </div>
                        <div className=" mt-4 col-lg-4">
                            <MDBCard className="h-100" style={{ boxShadow: "-2px 2px 13px 0 hsla(0,0%,82.4%,.3)", border: ".5px solid #f0f0f0" }}>
                                <MDBCardBody>
                                    <MDBCardTitle>Visa Type</MDBCardTitle>
                                    <hr />
                                    <MDBRow className="d-flex align-items-center">

                                        <MDBCol size="12" >

                                            <MDBRow >

                                                <MDBCol lg="6">
                                                    <input defaultChecked type="radio" id="visa_type" name="visa_type" value="Standard" onChange={this.handleVisaTypeChange} /> Standard Visa
                                         </MDBCol>
                                                <MDBCol lg="6">
                                                    <input type="radio" id="visa_type" name="visa_type" value="Express" onChange={this.handleVisaTypeChange} /> Express Visa
                                         </MDBCol>
                                            </MDBRow>
                                        </MDBCol>

                                    </MDBRow>
                                </MDBCardBody>
                            </MDBCard>
                        </div>
                        <div className=" mt-4 col-lg-4">
                            <MDBCard className="h-100" style={{ boxShadow: "-2px 2px 13px 0 hsla(0,0%,82.4%,.3)", border: ".5px solid #f0f0f0" }}>
                                <MDBCardBody>
                                    <MDBCardTitle>Entry Type</MDBCardTitle>
                                    <hr />
                                    <MDBRow className="d-flex align-items-center">

                                        <MDBCol size="12"  >

                                            <MDBRow >
                                                <MDBCol lg="6">
                                                    <input defaultChecked type="radio" id="entries" name="entries" value="Single" onChange={this.handleEntryTypeChange} /> Single Entry
                                      </MDBCol>
                                                <MDBCol lg="6">
                                                    <input type="radio" id="entries" name="entries" value="Multi" onChange={this.handleEntryTypeChange} /> Multi Entry
                                      </MDBCol>
                                            </MDBRow>
                                        </MDBCol>
                                    </MDBRow>
                                </MDBCardBody>
                            </MDBCard>
                        </div>
                    </div>
                }
                {(this.state.isVisaType && this.state.isEntryType) &&
                    <div className="mt-4">
                        <MDBCard style={{ boxShadow: "-2px 2px 13px 0 hsla(0,0%,82.4%,.3)", border: ".5px solid #f0f0f0" }}>
                            {/* <MDBCardBody> */}
                            <MDBCardBody>
                                <MDBCardTitle>Visa Offers
                                {(this.state.showSupportedCur) &&
                                        <Select
                                            className="col-1 col-md-2  float-right pr-0 pl-0"
                                            name="selected_currency"
                                            onChange={this.handleOptionChange}
                                            value={this.state.selected_currency}
                                        >
                                            {
                                                this.state.supported_currency.map((flag) =>
                                                    <MenuItem value={flag} key={flag}>
                                                        {/* <img src={flag.flag} style={{height: '1rem', width: '1.2rem'}} id={styles.flagThumbnail} /> */}
                                                    &nbsp; {flag}
                                                    </MenuItem>
                                                )
                                            }
                                        </Select>
                                    }
                                </MDBCardTitle>
                                <hr className="mb-0" />
                            </MDBCardBody>

                            <MDBNav className="nav-tabs">
                                <MDBNavItem>
                                    <MDBNavLink link to="#" active={this.state.activeItem === "1"} onClick={this.toggle("1")} role="tab" >
                                        Tourist
                                        </MDBNavLink>
                                </MDBNavItem>
                                <MDBNavItem>
                                    <MDBNavLink link to="#" active={this.state.activeItem === "2"} onClick={this.toggle("2")} role="tab" >
                                        Business
                                        </MDBNavLink>
                                </MDBNavItem>
                                <MDBNavItem>
                                    <MDBNavLink link to="#" active={this.state.activeItem === "3"} onClick={this.toggle("3")} role="tab" >
                                        Student
                                        </MDBNavLink>
                                </MDBNavItem>
                                <MDBNavItem>
                                    <MDBNavLink link to="#" active={this.state.activeItem === "4"} onClick={this.toggle("4")} role="tab" >
                                        Transit
                                        </MDBNavLink>
                                </MDBNavItem>
                            </MDBNav>
                            <MDBTabContent activeItem={this.state.activeItem} >
                                <MDBTabPane tabId="1" role="tabpanel">
                                    <MDBContainer fluid style={{ padding: '0 2%' }}>
                                        {no_tourist}
                                        <MDBRow>
                                            {
                                                this.state.touristVisa.map((tourist_visa) => {
                                                    // console.log(tourist_visa)
                                                    // console.log(tourist_visa.length)
                                                    //console.log("Tourist visa array >>>" + JSON.stringify(tourist_visa.visa));
                                                    if (tourist_visa.type === this.state.visa_type && tourist_visa.option === this.state.entry_type) {
                                                        //console.log("tourist visa array >>>" + JSON.stringify(tourist_visa.visa));                                                                                                                       
                                                        if (tourist_visa.visa.length === 0) {
                                                            //console.log("Tourist visa array is empty ...");                                                                
                                                            return no_tourist = <p style={{ marginBottom: '1rem', marginTop: '1rem', marginLeft: '1rem' }}>No visa offers for Tourist</p>
                                                        } else {
                                                            return tourist_visa.visa.map(this.offerCards)
                                                        }
                                                        //return tourist_visa.visa.map(this.offerCards)                                               
                                                    }

                                                })
                                            }
                                        </MDBRow>
                                    </MDBContainer>
                                </MDBTabPane>
                                <MDBTabPane tabId="2" role="tabpanel">
                                    <MDBContainer fluid style={{ padding: '0 2%' }}>
                                        {no_business}
                                        <MDBRow>
                                            {
                                                this.state.businessVisa.map((business_visa) => {
                                                    // console.log()
                                                    //console.log("Business visa array >>>" + JSON.stringify(business_visa.visa));
                                                    if (business_visa.type === this.state.visa_type && business_visa.option === this.state.entry_type) {
                                                        //console.log("Business visa array >>>" + JSON.stringify(business_visa.visa));
                                                        if (business_visa.visa.length === 0) {
                                                            //console.log("Business visa array is empty ...");                                                                
                                                            return no_business = <p style={{ marginBottom: '1rem', marginTop: '1rem', marginLeft: '1rem' }}>No visa offers for Business</p>
                                                        } else {
                                                            return business_visa.visa.map(this.offerCards)
                                                        }
                                                        //return business_visa.visa.map(this.offerCards)
                                                    }
                                                })
                                            }
                                        </MDBRow>
                                    </MDBContainer>
                                </MDBTabPane>
                                <MDBTabPane tabId="3" role="tabpanel">
                                    <MDBContainer fluid style={{ padding: '0 2%' }}>
                                        {no_student}
                                        <MDBRow>
                                            {
                                                this.state.studentVisa.map((student_visa) => {
                                                    // console.log("student visa")
                                                    //console.log("Transit visa array >>>" + JSON.stringify(student_visa.visa));
                                                    if (student_visa.type === this.state.visa_type && student_visa.option === this.state.entry_type) {
                                                        // console.log("student_visa.visa.length "+student_visa.visa.length)
                                                        //console.log("Transit visa array >>>" + JSON.stringify(student_visa.visa));
                                                        if (student_visa.visa.length === 0) {
                                                            //console.log("Student visa array is empty ...");                                                                
                                                            return no_student = <p style={{ marginBottom: '1rem', marginTop: '1rem', marginLeft: '1rem' }}>No visa offers for Student</p>
                                                        } else {
                                                            return student_visa.visa.map(this.offerCards)
                                                        }
                                                        //return student_visa.visa.map(this.offerCards)
                                                    }
                                                })
                                            }
                                        </MDBRow>
                                    </MDBContainer>
                                </MDBTabPane>
                                <MDBTabPane tabId="4" role="tabpanel">
                                    <MDBContainer fluid style={{ padding: '0 2%' }}>
                                        {no_transit}
                                        <MDBRow>
                                            {
                                                this.state.transitVisa.map((transit_visa) => {
                                                    // console.log(transit_visa)
                                                    //console.log("Transit visa array >>>" + JSON.stringify(transit_visa.visa));
                                                    if (transit_visa.type === this.state.visa_type && transit_visa.option === this.state.entry_type) {
                                                        //console.log("Transit visa array >>>" + JSON.stringify(transit_visa.visa));
                                                        if (transit_visa.visa.length === 0) {
                                                            //console.log("Tourist visa array is empty ...");                                                                
                                                            return no_transit = <p style={{ marginBottom: '1rem', marginTop: '1rem', marginLeft: '1rem' }}>No visa offers for Transit</p>
                                                        } else {
                                                            return transit_visa.visa.map(this.offerCards)
                                                        }
                                                        //return transit_visa.visa.map(this.offerCards)
                                                    }
                                                })
                                            }
                                        </MDBRow>
                                    </MDBContainer>
                                </MDBTabPane>
                            </MDBTabContent>

                            {/* </MDBCardBody> */}
                        </MDBCard>
                    </div>
                }
                {this.state.selected_visa_type !== 'visa' && <>
                {this.state.isRequiredDoc &&
                    <div className="mt-4">
                        <MDBCard style={{ boxShadow: "-2px 2px 13px 0 hsla(0,0%,82.4%,.3)", border: ".5px solid #f0f0f0" }} >
                            <MDBCardBody>
                                <MDBCardTitle>Required Documents </MDBCardTitle>
                                <hr />
                                <MDBRow>
                                    {this.state.requiredDocuments.map(this.requiredDocs)}
                                    {/* <MDBCol sm="6" lg="3"><p><img style={{paddingBottom:'1%'}} src={document} /> Passport Back Page</p></MDBCol>
                                    <MDBCol sm="6" lg="3"><p><img style={{paddingBottom:'1%'}} src={document} /> Travel E-Ticket</p></MDBCol>
                                    <MDBCol sm="6" lg="3"><p><img style={{paddingBottom:'1%'}} src={document} /> Bank Statement</p></MDBCol> */}
                                </MDBRow>
                            </MDBCardBody>
                        </MDBCard>
                    </div>
                }

                {this.state.isUploadDoc &&
                    <>
                        <div className="mt-4 mb-5">
                            <MDBCard style={{ boxShadow: "-2px 2px 13px 0 hsla(0,0%,82.4%,.3)", border: ".5px solid #f0f0f0" }}>
                                <MDBCardBody>
                                    <MDBCardTitle>Upload Documents</MDBCardTitle>
                                    <hr />
                                    <Dragger {...this.doc_props} style={{ maxHeight: "10rem" }} >
                                        <p className="ant-upload-drag-icon">
                                            {/* <InboxOutlined /> */}
                                            <img src={upload_icon} width={80} />
                                        </p>
                                        <p className="ant-upload-text">Drop document(s) here or click to upload</p>
                                        <p className="ant-upload-hint">
                                            <p style={{ color: 'grey' }}>(Supported formats JPG, PNG, PDF)</p>
                                        </p>
                                    </Dragger>
                                    {/* {this.uploadedDocCards} */}
                                    <MDBRow >
                                        {this.state.uploadedDoc.map(this.uploadedDocCards)}
                                    </MDBRow>
                                </MDBCardBody>
                            </MDBCard>
                        </div>
                    </>
                }
                { localStorage.getItem("host") === "visadone" &&
                <div className="mt-4 mb-5">
                    <MDBCard style={{ boxShadow: "-2px 2px 13px 0 hsla(0,0%,82.4%,.3)", border: ".5px solid #f0f0f0" }}>
                                <MDBCardBody>
                                    <MDBCardTitle>Disclaimer</MDBCardTitle>
                                    <hr />
                                    {/* <MDBRow  > */}
                                    <ul style={{"marginLeft": 0, "paddingLeft": "20px"}} >
                                        <li>
                                            Please note that the processing time indicated are from the time they are submitted to the respective visa decision making authority. Processing time may vary under exceptional circumstances beyond the control of Visadone.
                                        </li>
                                        <li>
                                        Please note that the document/documents list shown are subject to change without prior notice. Any additional documents/information required will be communicated after careful evaluation of the application.
                                        </li>
                                        </ul>
                                    {/* </MDBRow> */}
                                     
                                    
                                     
                                </MDBCardBody>
                    </MDBCard>
                </div>
                }
                <div style={{ marginBottom: '10rem'}}></div>
                </>}
                {this.state.showDeleteModall &&
                    <MDBModal centered isOpen={this.state.showDeleteModall} toggle={this.deleteToggle}>
                        <MDBModalHeader toggle={this.deleteToggle}>Delete Document</MDBModalHeader>
                        <MDBModalBody>
                            Are you sure, you want to delete the document?
                  </MDBModalBody>
                        <MDBModalFooter>
                            <MDBBtn color='white' style={{ textTransform: 'none' }} onClick={this.deleteToggle} >Cancel</MDBBtn>
                            <MDBBtn color="dark" style={{ textTransform: 'none' }} onClick={this.handleModalDeleteClick}>Delete</MDBBtn>

                        </MDBModalFooter>
                    </MDBModal>

                }

                {/* <div className="mt-4">
                <MDBCard>
                    <MDBNav className="nav-tabs mt-5">
                    <MDBNavItem>
                        <MDBNavLink link to="#" active={this.state.activeItem === "1"} onClick={this.toggle("1")} role="tab" >
                        Applicant 1
                        </MDBNavLink>
                    </MDBNavItem>
                    <MDBNavItem>
                        <MDBNavLink link to="#" active={this.state.activeItem === "2"} onClick={this.toggle("2")} role="tab" >
                        Applicant 2
                        </MDBNavLink>
                    </MDBNavItem>
                    </MDBNav>
                    <MDBTabContent activeItem={this.state.activeItem} >
                    <MDBTabPane tabId="1" role="tabpanel">
                        {reviewForm()}
                    </MDBTabPane>
                    <MDBTabPane tabId="2" role="tabpanel">
                        {reviewForm()}
                    </MDBTabPane>
                    </MDBTabContent>
                </MDBCard>
                </div> */}
                {/* <div className="mt-4 mb-4">
                    <MDBCard>
                        <MDBCardBody>
                            <MDBRow>
                                <MDBCol size="12" lg="2">
                                    <h5>Activity</h5>
                                </MDBCol>
                                <MDBCol size="12" lg="6" />
                                <MDBCol size="12" lg="4">
                                    <MDBRow>
                                        <MDBCol >Application Status</MDBCol>
                                        <MDBCol className="text-right" ><MDBBadge color="warning" style={{backgroundColor:'#2E3192'}}>Pending</MDBBadge></MDBCol>
                                    </MDBRow>
                                </MDBCol>
                            </MDBRow>
                            <hr/>
                            <MDBCol md="6">
                                <MDBInput type="textarea" label="Enter your comments" rows="2" placeholder="Add a comment"/>
                                <MDBRow>
                                    <MDBCol lg="9" />
                                    <MDBCol lg="3">
                                        <MDBBtn id="submit_comment" style={{color:'white',backgroundColor:' #2E3192',width:'100%', fontSize:'calc(8px + .5rem)',textTransform:'none'}} color="none">Submit</MDBBtn>
                                    </MDBCol>
                                </MDBRow>
                                <Stepper step orientation="vertical">
                                    <Step >
                                        <StepLabel StepIconComponent={stepsIcon}>
                                            <p className="m-1">Aditya Durgude</p>
                                        </StepLabel>
                                        <StepContent>
                                            <small>23 Oct, 2020 | 4:12 PM</small>
                                            <p>Uploaded additional documents</p>
                                        </StepContent>
                                    </Step>
                                    <Step active>
                                        <StepLabel StepIconComponent={stepsIcon}>
                                            <p className="m-1">Sagar Sutar, <span style={{color:'grey'}}>Admin</span></p>
                                        </StepLabel>
                                        <StepContent>
                                            <small>23 Oct, 2020 | 4:12 PM</small>
                                            <p>Please upload passport front and back again</p>
                                            <a>Upload required documents</a>
                                        </StepContent>
                                    </Step>
                                    <Step active>
                                        <StepLabel StepIconComponent={stepsIcon}>
                                            <p className="m-1">Aditya Durgude</p>
                                        </StepLabel>
                                        <StepContent>
                                            <small>23 Oct, 2020 | 4:12 PM</small>
                                            <p>Visa Application submitted for review</p>
                                        </StepContent>
                                    </Step>
                                </Stepper>
                            </MDBCol>
                        </MDBCardBody>
                    </MDBCard>
                </div> */}
                <div className="modal fade" id="infoModal" tabindex="-1" role="dialog" aria-labelledby="infoModalLabel" aria-hidden="true" isOpen={this.state.modal} toggle={() => this.toggleModal()}>
                    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
                        <div className="modal-content">
                            <div className="modal-header">

                                <h3 className="modal-title" id="infoModalLabel"><b>Required Documents</b></h3>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <p> {this.state.modalText} </p>
                            </div>
                            <div className="modal-footer">
                                <MDBBtn color="none" data-dismiss="modal" style={{ color: 'white', backgroundColor: 'black', textTransform: 'none', }}>Close</MDBBtn>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="modal fade" id="visaOfferModal" tabindex="-1" role="dialog" aria-labelledby="visaOfferModalLabel" aria-hidden="true" isOpen={this.state.modal} toggle={() => this.toggleModal()}>
                    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h3 className="modal-title" id="visaOfferModalLabel"><b>Visa Offer Details</b></h3>

                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <h6><b> {this.state.detailMessage} </b></h6>
                                <p> {this.state.someMessage} </p>
                                <div>
                                    <MDBTable className="table-borderd border table">
                                        <MDBTableHead style={{ backgroundColor: '#f1f1f1' }}>
                                            <tr>
                                                <th>Description</th>

                                                <th>Visa Fee</th>
                                            </tr>
                                        </MDBTableHead>
                                        <MDBTableBody>
                                            <tr>
                                                <td>Adult</td>

                                                <td> {this.state.currencyType} {this.state.adultFee} </td>
                                            </tr>
                                            <tr>
                                                <td>Service Fee</td>

                                                <td>{this.state.currencyType} {this.state.visaeroFee} </td>
                                            </tr>


                                            {this.state.additionalTaxes.map((tax) => (
                                                <tr>
                                                    <td>{tax.taxname} ({tax.taxpercent}%) </td>

                                                    <td>{this.state.currencyType} {tax.tax_amount.toFixed(2)} </td>
                                                </tr>
                                            ))}



                                            <tr>
                                                {/* <td>Any other charges</td> */}
                                            </tr>
                                        </MDBTableBody>
                                        {/* <MDBTableFoot style={{backgroundColor:'#f1f1f1'}}> */}
                                        <tr>
                                            <td>Total</td>

                                            <td><h6><b>{this.state.currencyType} {this.state.totalAmount} </b></h6></td>
                                        </tr>
                                        {/* </MDBTableFoot> */}
                                    </MDBTable>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <MDBBtn color="none" data-dismiss="modal" style={{ color: 'white', backgroundColor: 'black', textTransform: 'none', }}>Close</MDBBtn>
                            </div>
                        </div>
                    </div>
                </div>
                <MDBRow id="footerRow" style={{ width: "100%", marginTop: "5%" }}>
                    <MDBFooter style={{ background: "#fff", position: "fixed", bottom: "0px", width: "100%", right: "0", borderTop: "1px solid #ccc", boxShadow: "0px 0 10px rgba(0, 0, 0, 0.2)", zIndex: "1" }} color="white" className="pb-1 pt-1 text-right">
                        <MDBRow>
                            {/* <MDBCol size="12" sm="6" md="6" lg="6" className="text-center" > */}
                            <div className="w-100 d-flex align-items-center justify-content-center position-absolute">

                                {
                                    this.state.showVisaofferError &&
                                    <MDBAlert color='danger' className="alert-danger w-50 m-auto  text-center">Please select Visa offer</MDBAlert>
                                }

                                {
                                    this.state.documentError &&
                                    <MDBAlert color='danger' className="alert-danger w-50 m-auto  text-center">Please upload document in supported format.(JPG, PNG, PDF, JPEG)</MDBAlert>
                                }

                                {
                                    this.state.showDocumentError &&
                                    <MDBAlert color='danger' className="alert-danger w-50 m-auto  text-center">Please upload required documents</MDBAlert>
                                }
                                {
                                    this.state.isError &&
                                    <MDBAlert color='danger' className="alert-danger w-50 m-auto  text-center">{this.state.ErrorMsg}</MDBAlert>
                                }
                                {/* </MDBCol> */}
                            </div>

                            <MDBCol size="12" sm="12" md="12" lg="12" style={{ textAlign: 'right' }}>
                                {/* <RouterLink to="/new-visa/organize"><MDBBtn id="reviewBtn" style={{color:'white',backgroundColor:'#673784',width:'40%', fontSize:'calc(8px + .5rem)',textTransform:'none'}} color="none">Organize Application</MDBBtn></RouterLink> */}
                                {this.state.isCORRequired ? 
                                <MDBBtn id="reviewBtn" disabled={this.state.selected_visa_type !== 'visa' || !localStorage.getItem('selected_visa_offer')} color="none" style={{ color: 'white', backgroundColor: this.state.brand_color, fontSize: 'calc(8px + .5rem)', textTransform: 'none' }} onClick={() => this.props.history.push('/new-visa/enquiry-form')}>Proceed</MDBBtn>:
                                <MDBBtn id="reviewBtn" color="none" style={{ color: 'white', backgroundColor: this.state.brand_color, fontSize: 'calc(8px + .5rem)', textTransform: 'none' }} onClick={this.handleOrganizeApplication}>Organize Application</MDBBtn>}
                            </MDBCol>
                        </MDBRow>
                    </MDBFooter>
                </MDBRow>
            </>
        )
    }
}

export default NewVisa;
